export class UserAuswahlSelectGebaeude {
    idGebaeude!: number; 
    selected!: boolean;

    constructor(idGebaeude: number, selected:boolean)
    {
      this.idGebaeude = idGebaeude;
      this.selected = selected;
    }
  }
  